import { useState, useEffect } from 'react';
import styled from '@emotion/styled';

import { Grid, Card, CardHeader, CardContent, CardActions, Button, Typography, IconButton, Icon, Divider } from '@mui/material';

import { CardBlockContainer, CardBlock, CardBlockHeader, CardSpacer } from '../../../utils/utilities/CardComponents';

import LocalOfferRoundedIcon from '@mui/icons-material/LocalOfferRounded';

import MultiStatusChip from '../../../utils/utilities/MultiStatusChip';

import SimpleChip from '../../../utils/utilities/SimpleChip';

import NoItemsFound from '../../../utils/NoItems';

import NoTimeline from '../../../utils/utilities/Timeline/NoTimeline';

import { BasicFlex, ScrollableContainer } from '../../../utils/Common';

import { formatGenericDate, formatGenericTime } from '../../../utils/util';

import { useQuery } from '@tanstack/react-query';

import FormDialog from '../../../utils/utilities/Dialog';
import EditSchedule from '../../Schedule/EditSchedule';

// new Event context
import { useNewEvent } from '../../../contexts/NewEvent';

// use pageData context
import { usePageData } from '../../../contexts/PageData';

// apiService
import { getSoldInventoryByCustomer } from '../../Inventory/apiService';

import ServiceHistoryComponent from '../../Inventory/Components/ServiceHistoryComponent';


const WigCard = ({ wig, handleSelect, selected }) => {

  return (
    <Card variant='outlined' onClick={() => handleSelect(wig.inventory_id)} sx={{borderColor: selected ? "secondary.main" : "", cursor: "pointer", width: "100%"}}>
      <CardHeader title={<BasicFlex width="fit-content" justifty="flex-start" gap="1rem"><LocalOfferRoundedIcon fontSize="small" color="basic" /> <div>{wig.wig_id}</div></BasicFlex>} subheader={<SimpleChip label={wig.sku} />} sx={{py: 1}}
        slotProps={{title: {sx: {fontSize: "1.3rem", mb: ".3rem", fontWeight: "500"}}, subheader: {sx: {fontSize: "1.2rem"}}}}
      />
      <Divider />
      <CardContent sx={{py: 1, pb: "1rem !important"}} >
        <BasicFlex>
          <BasicFlex dir="column">
            <div>Sold On</div>
            <div>{formatGenericDate(wig.date_sold)}</div>
          </BasicFlex>

        </BasicFlex>
      </CardContent>
    </Card>
  )
}


const CustomerWigsTab = () => {
  const { data = {} } = usePageData();

  const [selectWig, setSelectWig] = useState(null);

  const handleSelect = (id) => {
    setSelectWig(id);
  }

  const { data: wigs } = useQuery({
    queryKey: ['inventory', 'customer', data?.customer_id],
    queryFn: () => getSoldInventoryByCustomer(data?.customer_id),
    enabled: !!data?.customer_id
  })

  return (
    <>
    <Grid container spacing={3}>
      
      <Grid size={{xs: 12, md: 6}}>

        <Card elevation={0} sx={{backgroundColor: "transparent"}}>

          <CardHeader title="Customer Wigs" sx={{pb: 1}} />

          <CardContent sx={{pt: 1}}>
            <BasicFlex dir="column" gap="1rem">
              {wigs?.length ? wigs?.map((wig, i) => (
                <WigCard key={i} wig={wig} handleSelect={handleSelect} selected={wig.inventory_id === selectWig} />
              )) : <NoItemsFound />}
            </BasicFlex>
          </CardContent>

        </Card>
       
      </Grid>

      <Grid size={{xs: 12, md: 6}}>

       {selectWig && <ServiceHistoryComponent key={selectWig} inventory_id={selectWig} /> }
       
      </Grid>

    </Grid>
    </>
  );

};

export default CustomerWigsTab;